import { Pipe, PipeTransform } from '@angular/core';

/**
 * Rewrites an "SM"/"TM" mark wrapped in parentheses (optionally single-quoted)
 * into raised, reduced-size superscript markup for markdown-rendered slide text:
 *
 *   "(SM)"  "'(SM)'"  "('SM')"  "(TM)"  ->  <sup class="service-mark">SM</sup>
 *
 * The parentheses and quotes are dropped. Non-matching text — including "(R)",
 * lowercase "(sm)" and bare "SM"/"TM" — is returned unchanged. The injected
 * markup is a <sup> with a class attribute, which is safe and survives markdown
 * sanitisation; sizing/positioning comes from the global `.service-mark` rule.
 */
const SERVICE_MARK_PATTERN = /'?\('?(SM|TM)'?\)'?/g;

@Pipe({ name: 'serviceMark' })
export class ServiceMarkPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return value ?? '';
    }
    return value.replace(
      SERVICE_MARK_PATTERN,
      (_match, mark) => `<sup class="service-mark">${mark}</sup>`,
    );
  }
}
